<!-- My Tickets -->
<div class="tabs-container">
  <div class="tab-content-group mt-5">
    <div
      class="tabs-with-btn"
      style="display: flex; justify-content: space-between"
    >
      <ul class="tab-group">
        <li
          *ngFor="let tab of tabs; index as i"
          class="tab"
          [class.active]="tab.active"
          (click)="changeTab(i)"
        >
          <i class="icon" [ngClass]="tab.iconClass"></i>
          {{ tab.title | translate }}
        </li>
      </ul>
      <div class="side-tab-div" *ngIf="activeIndex == 1">
        <button
          routerLink="/tickets/transferred-weapons"
          class="btn btn-outline-primary gap-1"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 20.75H6.99997C2.74997 20.75 1.35997 19.48 1.25997 15.52C1.25997 15.32 1.32997 15.12 1.46997 14.98C1.60997 14.84 1.79997 14.75 2.00997 14.75C3.51997 14.75 4.74997 13.51 4.74997 12C4.74997 10.49 3.51997 9.25 2.00997 9.25C1.80997 9.25 1.61997 9.17 1.46997 9.02C1.31997 8.87 1.24997 8.68 1.25997 8.48C1.35997 4.52 2.74997 3.25 6.99997 3.25H17C21.41 3.25 22.75 4.59 22.75 9V15C22.75 19.41 21.41 20.75 17 20.75ZM2.78997 16.18C2.95997 18.72 3.81997 19.25 6.99997 19.25H17C20.58 19.25 21.25 18.57 21.25 15V9C21.25 5.43 20.58 4.75 17 4.75H6.99997C3.81997 4.75 2.95997 5.29 2.78997 7.82C4.75997 8.2 6.24997 9.93 6.24997 12C6.24997 14.07 4.75997 15.8 2.78997 16.18Z"
              fill="#43C0B5"
            />
            <path
              d="M9 8.25C8.59 8.25 8.25 7.91 8.25 7.5V4C8.25 3.59 8.59 3.25 9 3.25C9.41 3.25 9.75 3.59 9.75 4V7.5C9.75 7.91 9.41 8.25 9 8.25Z"
              fill="#43C0B5"
            />
            <path
              d="M9 20.75C8.59 20.75 8.25 20.41 8.25 20V16.5C8.25 16.09 8.59 15.75 9 15.75C9.41 15.75 9.75 16.09 9.75 16.5V20C9.75 20.41 9.41 20.75 9 20.75Z"
              fill="#43C0B5"
            />
            <path
              d="M13.0399 15.65C12.7999 15.65 12.5599 15.57 12.3599 15.43C11.9999 15.17 11.8199 14.73 11.8999 14.29L12.1099 13.1L11.2399 12.25C10.9199 11.94 10.8099 11.48 10.9399 11.06C11.0799 10.64 11.4399 10.33 11.8799 10.27L13.0799 10.09L13.6199 9.00001C13.8199 8.60001 14.2199 8.35001 14.6599 8.35001C15.1099 8.35001 15.5099 8.60001 15.6999 9.00001L16.2399 10.09L17.4399 10.27C17.8799 10.33 18.2399 10.64 18.3799 11.06C18.5199 11.48 18.3999 11.94 18.0799 12.25L17.2099 13.1L17.4199 14.29C17.4999 14.73 17.3199 15.17 16.9599 15.43C16.5999 15.69 16.1299 15.72 15.7399 15.52L14.6699 14.96L13.5899 15.52C13.4199 15.61 13.2299 15.65 13.0399 15.65ZM12.7699 11.65L13.2799 12.15C13.5599 12.42 13.6799 12.8 13.6199 13.18L13.4999 13.88L14.1299 13.55C14.4699 13.37 14.8699 13.37 15.2099 13.55L15.8399 13.88L15.7199 13.18C15.6599 12.79 15.7799 12.41 16.0599 12.15L16.5699 11.65L15.8699 11.55C15.4899 11.49 15.1599 11.25 14.9899 10.91L14.6799 10.27L14.3699 10.91C14.1999 11.25 13.8699 11.49 13.4899 11.55L12.7699 11.65Z"
              fill="#43C0B5"
            />
          </svg>
          {{ "Sport.TransferredToYou" | translate }}
        </button>
        <span
          class="text-muted"
          *ngIf="invoices?.data?.length > 0 && !isMobile"
          style="align-content: center; font-size: medium; margin: 0 5px"
          >{{ invoices?.meta?.itemCount }}
          {{ "Sport.Ticket" | translate }}</span
        >
        <form [formGroup]="filterForm">
          <div>
            <div class="filters">
              <ng-select
                (change)="onFilterChange()"
                formControlName="ticketType"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-option value="">
                  {{ "AllTickets" | translate }}
                </ng-option>
                <ng-option value="false">
                  {{ "MyTickets" | translate }}
                </ng-option>
                <ng-option value="true">
                  {{ "TransferredToMe" | translate }}
                </ng-option>
              </ng-select>
              <ng-select
                (change)="onFilterChange()"
                formControlName="championId"
                [clearable]="false"
                [style]="isMobile ? 'max-width: 100%' : 'max-width: 270px'"
                [searchable]="false"
              >
                <ng-container>
                  <ng-option value="">
                    {{ "AllChampions" | translate }}
                  </ng-option>
                  <ng-option
                    value=""
                    *ngFor="let champion of champions"
                    [value]="champion.id"
                  >
                    {{ helpers.getElementTranslatedName(champion) }}
                  </ng-option>
                </ng-container>
              </ng-select>
            </div>
          </div>
        </form>
        <div class="form-check">
          <input
            [disabled]="!invoices?.data?.length"
            class="form-check-input"
            type="checkbox"
            (change)="toggleSelectAll()"
            [checked]="invoices?.data?.length && selectAll"
          />
          <label class="form-check-label">
            {{ "Sport.SelectAll" | translate }}
          </label>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let tab of tabs">
      <div class="tab-content" *ngIf="tab.active">
        <div *ngIf="tab.title == 'Events'">
          <!-- Transactions Tab Content -->
          <app-evento-tickets></app-evento-tickets>
        </div>

        <div *ngIf="tab.title == 'Matches'">
          <app-sport-tickets
            (invoicesChanged)="invoices = $event"
            [selectAll]="selectAll"
            [filter]="filter"
          ></app-sport-tickets>
        </div>
      </div>
    </ng-container>
  </div>
</div>
